import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { useAuth } from "./AuthContext";

type Props = {
  children: React.ReactElement;
  allowedRoles?: Array<"superadmin" | "hospital_admin">;
  requireHospitalMatch?: boolean; // if true, hospital_admin may access only their hospital
};

export const ProtectedRoute: React.FC<Props> = ({
  children,
  allowedRoles,
  requireHospitalMatch,
}) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();
  // const params = useParams(); // for :id param

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (allowedRoles && user && !allowedRoles.includes(user.role as any)) {
    return <Navigate to="/" replace />;
  }
  // if (requireHospitalMatch && user?.role === "hospital_admin") {
  //   const routeHospitalId = params.id ?? params.hospitalId ?? null; // flexible param names
  //   // if (!routeHospitalId || routeHospitalId !== user.hospital) {
  //   //   return <Navigate to={`/hospitals/${user.hospital}`} replace />;
  //   // }
  // }

  return children;
};
